declare const angular : ng.IAngularStatic;
declare var language: any;

import { DialogsService } from "./uikit.dialogs";

let offsetBlock = (currBlock) => {
	let currBlockBottom : any = $(currBlock).css("bottom");
	currBlockBottom = parseInt(currBlockBottom.substr(0, currBlockBottom.length - 2), 10)

	let currBlockHeight = $(currBlock).height()
	$(currBlock).remove()

	$('.bootstrap-growl').each(function(){
		let bottom : any = $(this).css("bottom");
		bottom = parseInt(bottom.substr(0, bottom.length - 2), 10)

		if(bottom > currBlockBottom){
			bottom = bottom - currBlockHeight - 10
			$(this).css("bottom", bottom.toString() + 'px')
			// в этом each мы опускаем блоки-алерты,которые располагались выше закрывающегося блока, вниз на высоту,
			// которая равна высоте блока плюс margin(отступ от соседнего блока)
		}
	})
}

const showGrowl = ($dialogs: DialogsService, message : string, type: string, textException? : string) => {
	let bottomOffset = 10;
	$("[data-alert-offset-bottom]:visible").each(function() {
		const rect = (this as HTMLElement).getBoundingClientRect();
		if (rect.top < window.innerHeight && rect.bottom > 0) {
			bottomOffset = Math.max(bottomOffset, window.innerHeight - rect.top + 10);
		}
	});

	let options = {
		element: 'body',
		offset: {
			from: "bottom",
			amount: bottomOffset,
		},
		align: "right", //# (left, right, or center)
		width: 300,
		delay: 9000,
		stackup_spacing: 10
	};

	let css = {
		"position": "fixed",
		"margin": 0,
		"z-index": "2000",
		"white-space": "pre-wrap",
		"display": "none",
	}

	let $alert = $("<div>")
	let $wrap = $("<div>")

	$wrap.addClass("bootstrap-growl");

	$alert.attr("class", "alert")
	$alert.css("margin-bottom", "0");;

	$alert.addClass("alert-" + type);

	let $cross = $("<span class=\"close\">&times;</span>").on("click", function(){
		offsetBlock($(this).parent().parent())
	});
	$alert.append($cross);

	$alert.append(message);
	let offsetAmount = options.offset.amount;

	$(".bootstrap-growl").each(function(){
		offsetAmount = Math.max(options.offset.amount, parseInt($(this).css(options.offset.from)) + $(this).outerHeight() + options.stackup_spacing);
	});

	css[options.offset.from] = offsetAmount + "px";

	$wrap.css(css);
	$wrap.css("width", options.width + "px")
	$(options.element).append($wrap);
	$wrap.css(options.align, "20px");

	$wrap.fadeIn()

	if(type == 'danger')
		$wrap.delay(30000)
	else
		$wrap.delay(options.delay)


	$wrap.fadeOut(function(){
		offsetBlock(this);
	});

	if(typeof textException == 'string' && textException != ""){
		let $link = $('<a></a>');
		$link.append(language.Generic.Common.kErrorDetails);
		$link.css('font-size', '11px');
		$link.css('cursor', 'pointer');
		$link.on("click", function(){
			$dialogs.error(textException);
			offsetBlock($(this).parent().parent());
			$(this).parent().remove();
		});


		$alert.append('<br/>');
		$alert.append($link);
	}


	$wrap.append($alert);
}

export class AlertsService{
	/*@ngInject*/
	constructor(private $dialogs : DialogsService){
	}

	success(message: string) {
		showGrowl(this.$dialogs, message, 'success');
	}

	error(message: string, textException? : string) {
		showGrowl(this.$dialogs, message, 'danger', textException);
	}

	info(message: string) {
		showGrowl(this.$dialogs, message, 'info');
	}

	warning(message: string) {
		showGrowl(this.$dialogs, message, 'warning');
	}
}

angular.module('uikit.alerts', ["uikit.dialogs"])
.service('$alerts', AlertsService);
